<div class="flex flex-col h-full">

  <!-- Title -->
  <div class="px-6 pt-5 pb-3">
    <span class="text-base text-grey-700">Select DMS Op Codes matching MOTOR service</span>
  </div>

  <div mat-dialog-content class="flex flex-col gap-3 flex-1 overflow-hidden px-6 pb-4 pt-4">

    <!-- Status cards -->
    <div class="flex gap-3">

      <!-- Left: MOTOR service info -->
      <fieldset class="status-card w-2/5 min-w-0 rounded flex items-start gap-2 px-3 py-2.5">
        <legend class="text-xs text-grey-600">MOTOR Service</legend>
        <div class="flex-1 min-w-0">
          <p class="text-sm text-grey-900 mt-1 leading-tight">{{ data.item.motorServiceName }}</p>
        </div>
      </fieldset>

      <!-- Center: Link status -->
      <div class="flex flex-col pt-2.5 w-1/5 place-content-between">
        <span class="rounded text-white h-7 flex items-center place-content-center"
          [ngClass]="hasSelections ? 'bg-green-500' : 'bg-orange-500'">
          <svg *ngIf="hasSelections" xmlns="http://www.w3.org/2000/svg" class="inline-block w-4 h-4 mr-1"
            fill="currentColor" viewBox="0 0 640 640">
            <path
              d="M451.5 160C434.9 160 418.8 164.5 404.7 172.7C388.9 156.7 370.5 143.3 350.2 133.2C378.4 109.2 414.3 96 451.5 96C537.9 96 608 166 608 252.5C608 294 591.5 333.8 562.2 363.1L491.1 434.2C461.8 463.5 422 480 380.5 480C294.1 480 224 410 224 323.5C224 322 224 320.5 224.1 319C224.6 301.3 239.3 287.4 257 287.9C274.7 288.4 288.6 303.1 288.1 320.8C288.1 321.7 288.1 322.6 288.1 323.4C288.1 374.5 329.5 415.9 380.6 415.9C405.1 415.9 428.6 406.2 446 388.8L517.1 317.7C534.4 300.4 544.2 276.8 544.2 252.3C544.2 201.2 502.8 159.8 451.7 159.8zM307.2 237.3C305.3 236.5 303.4 235.4 301.7 234.2C289.1 227.7 274.7 224 259.6 224C235.1 224 211.6 233.7 194.2 251.1L123.1 322.2C105.8 339.5 96 363.1 96 387.6C96 438.7 137.4 480.1 188.5 480.1C205 480.1 221.1 475.7 235.2 467.5C251 483.5 269.4 496.9 289.8 507C261.6 530.9 225.8 544.2 188.5 544.2C102.1 544.2 32 474.2 32 387.7C32 346.2 48.5 306.4 77.8 277.1L148.9 206C178.2 176.7 218 160.2 259.5 160.2C346.1 160.2 416 230.8 416 317.1C416 318.4 416 319.7 416 321C415.6 338.7 400.9 352.6 383.2 352.2C365.5 351.8 351.6 337.1 352 319.4C352 318.6 352 317.9 352 317.1C352 283.4 334 253.8 307.2 237.5z" />
          </svg>
          <svg *ngIf="!hasSelections" xmlns="http://www.w3.org/2000/svg" class="inline-block w-4 h-4 mr-1"
            fill="currentColor" viewBox="0 0 640 640">
            <path
              d="M73 39.1C63.6 29.7 48.4 29.7 39.1 39.1C29.8 48.5 29.7 63.7 39 73.1L567 601.1C576.4 610.5 591.6 610.5 600.9 601.1C610.2 591.7 610.3 576.5 600.9 567.2L478.9 445.2C483.1 441.8 487.2 438.1 491 434.3L562.1 363.2C591.4 333.9 607.9 294.1 607.9 252.6C607.9 166.2 537.9 96.1 451.4 96.1C414.1 96.1 378.3 109.4 350.1 133.3C370.4 143.4 388.8 156.8 404.6 172.8C418.7 164.5 434.8 160.1 451.4 160.1C502.5 160.1 543.9 201.5 543.9 252.6C543.9 277.1 534.2 300.6 516.8 318L445.7 389.1C441.8 393 437.6 396.5 433.1 399.6L385.6 352.1C402.1 351.2 415.3 337.7 415.8 321C415.8 319.7 415.8 318.4 415.8 317.1C415.8 230.8 345.9 160.2 259.3 160.2C240.1 160.2 221.4 163.7 203.8 170.4L73 39.1zM257.9 224C258.5 224 259 224 259.6 224C274.7 224 289.1 227.7 301.7 234.2C303.5 235.4 305.3 236.5 307.2 237.3C334 253.6 352 283.2 352 316.9C352 317.3 352 317.7 352 318.1L257.9 224zM378.2 480L224 325.8C225.2 410.4 293.6 478.7 378.1 479.9zM171.7 273.5L126.4 228.2L77.8 276.8C48.5 306.1 32 345.9 32 387.4C32 473.8 102 543.9 188.5 543.9C225.7 543.9 261.6 530.6 289.8 506.7C269.5 496.6 251 483.2 235.2 467.2C221.2 475.4 205.1 479.8 188.5 479.8C137.4 479.8 96 438.4 96 387.3C96 362.8 105.7 339.3 123.1 321.9L171.7 273.3z" />
          </svg>{{ hasSelections ? (selectedCount + ' Linked') : 'Not Linked' }}
        </span>
        <div class="flex w-full place-content-center">
          <button *ngIf="hasSelections"
            class="flex rounded px-2 h-7 items-center place-content-center bg-white border text-orange-500 border-orange-500"
            (click)="unlinkAll()">
            Unlink All
          </button>
        </div>
      </div>

      <!-- Right: selected DMS services (chip list) -->
      <fieldset class="selection-card w-2/5 min-w-0 rounded px-3 py-2.5" [class.has-selection]="hasSelections">
        <legend class="text-xs text-grey-600">DMS Services</legend>
        <ng-container *ngIf="hasSelections; else noSelection">
          <div class="flex flex-wrap gap-1 max-h-[72px] overflow-y-auto">
            <span *ngFor="let entry of selectedGroups | keyvalue"
              class="selected-chip inline-flex items-center bg-green-100 text-green-900 text-xs rounded px-2 py-0.5">
              <span class="chip-label">{{ entry.value.workOrderLocationOpCode }} &middot; {{ entry.value.name }}</span>
              <button class="chip-remove ml-1 text-green-600 hover:text-green-900"
                (click)="removeSelected(entry.key); $event.stopPropagation()" aria-label="Remove">
                &times;
              </button>
            </span>
          </div>
        </ng-container>
        <ng-template #noSelection>
          <div class="flex flex-col min-h-[56px]">
            <div class="flex flex-col items-center justify-center flex-1">
              <p class="text-sm text-grey-400 italic">No services mapped &mdash; select from the list below</p>
            </div>
          </div>
        </ng-template>
      </fieldset>

    </div>

    <!-- Filters -->
    <div class="flex gap-3">
      <div class="flex flex-col flex-1">
        <label class="text-xs text-grey-600 mb-1">Search by op code or name</label>
        <div class="flex items-center border border-grey-300 rounded px-3 h-9 bg-white">
          <mat-icon class="text-grey-400 shrink-0 mr-1.5"
            style="font-size: 18px; height: 18px; width: 18px;">search</mat-icon>
          <input [formControl]="searchControl" placeholder="Search for..." autocomplete="off"
            class="outline-none text-sm flex-1 bg-transparent text-grey-700 placeholder-grey-400" />
        </div>
      </div>
      <div class="flex flex-col w-40">
        <label class="text-xs text-grey-600 mb-1">Category</label>
        <select [formControl]="categoryControl"
          class="border border-grey-300 rounded px-3 h-9 text-sm text-grey-700 bg-white outline-none">
          <option value="">All</option>
          <option *ngFor="let cat of loadedCategories" [value]="cat.id">{{ cat.description }}</option>
        </select>
      </div>
    </div>

    <!-- Service group list -->
    <div class="flex-1 border border-grey-200 overflow-y-auto min-h-0">

      <ng-container *ngFor="let section of groupedSections; trackBy: trackByCategoryId">
        <!-- Category header -->
        <div class="px-4 py-1.5 border-b border-grey-200 sticky top-0 z-10"
          [ngClass]="isSelectedSection(section) ? 'bg-green-50' : 'bg-grey-100'">
          <span class="text-xs font-semibold uppercase tracking-wide"
            [ngClass]="isSelectedSection(section) ? 'text-green-900' : 'text-grey-600'">
            {{ section.categoryName }}
          </span>
        </div>
        <!-- Service group rows -->
        <button type="button" *ngFor="let sg of section.items; trackBy: trackById"
          class="op-code-row w-full flex items-center text-left px-2 py-1.5 border-b border-grey-100 rounded-none"
          [class.selected]="isSelected(sg)" (click)="toggleGroup(sg)">
          <mat-checkbox class="mr-2 pointer-events-none" [checked]="isSelected(sg)"></mat-checkbox>
          <span class="op-code-chip shrink-0 mr-3 op-code-id">{{ sg.workOrderLocationOpCode ?? '—' }}</span>
          <span class="flex-1 min-w-0 text-sm op-code-name truncate">{{ sg.name }}</span>
          <span class="text-xs shrink-0 ml-2 op-code-time" *ngIf="sg.estimatedTime">
            {{ sg.estimatedTime | number: '1.1-1' }}h
          </span>
        </button>
      </ng-container>

      <div *ngIf="groupedSections.length === 0" class="flex items-center justify-center h-16">
        <span class="text-sm text-grey-400">No results found</span>
      </div>

    </div>

  </div>

  <!-- Footer: selected count + actions -->
  <div class="flex justify-between items-center px-6 py-4">
    <span class="text-xs text-blue-600">{{ selectedCount }} service{{ selectedCount === 1 ? '' : 's' }} selected</span>
    <div class="flex gap-2">
      <button mat-button [mat-dialog-close]="null" class="rounded">Cancel</button>
      <button mat-raised-button color="primary" class="rounded" [disabled]="!canSave" (click)="save()">Save</button>
    </div>
  </div>

</div>